import './accountOwner.scss';
import React from 'react';
import { useContext } from 'react';
import { AppContext } from '../../../../context/appContext';
import { PlainText } from '../../../plainText/plainText';

export interface IProps {

}

export function AccountOwner(props: IProps) {
    const appContext = useContext(AppContext);
    const { enterpriseInfo } = appContext.state;

    return (
        <div className="account-belong-tip">
            <div className="tip-desc">
                <PlainText>当前账户由</PlainText>
                <span className="name"> { enterpriseInfo.enterprise_name } </span>
                <PlainText>管理</PlainText>
            </div>
        </div>
    );
}
